import * as settings from './20220628-settings';
import * as idsCrm from './20220906-ids-crm';
import migrate from '../migrate';

export const migrations = [settings, idsCrm];

export default migrate(migrations);
